const FieldWrapperWithoutLabel = ({children, classes = ''}) => (
    <div className={'input-field-wrapper' + classes}>
        {children}
        <span className="underline"></span>
    </div>
)

export default FieldWrapperWithoutLabel